module.exports = __webpack_public_path__ + "img/11-sdg-full@2x.dea36a23.png";